module.exports = __webpack_public_path__ + "static/Nathan.4093c923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Nathan.jpg
// module id = 1317
// module chunks = 137408898365125